import styled, { keyframes } from 'styled-components'
import { Arrow } from  '../../assets'

const showDelay = keyframes`
  0% { opacity: 0 }
  100% { opacity: 1}
`

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  cursor: pointer;
  border: solid 1px #679296;
  transition: all .5s ease;
  box-sizing: border-box;
  color: #112426;
  opacity: 0;
  padding: 21px 21px 0 21px;
  min-height: 650px;
  border: solid 1px transparent;
  animation: ${showDelay} 1s ease-out forwards ${p => p.delay? p.delay: '1s'};

  &:hover {
    border: solid 1px #679296;

    .title {
      opacity: 1;
      transform: translateY(75px);
    }

    .arrow {
      opacity: 1;
      background-position: 20px 0px;
    }

    .description, .description_2 {
      opacity: 1;
      transform: translateX(-40px);
    }

    .image {
      &:after {
        background: #244951;
      }
    }
  }
`

export const ImageContainer = styled.div`
  position: relative;
  max-width: 588px;
  height: 500px;
  background: url(${p => p.src}) no-repeat center center, #AEDBD9;
  background-size: cover;
  background-color: #2D5A64;

  &:after {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background:#2D5A64;
    opacity: .8;
    transition: all .3s ease-in-out; 
  }
`

export const TitleContainer = styled.div`
  position: relative;
  width: 70%;
  height: 40px;
  padding: 0 20px;

  @media (min-width: 768px) {
    padding: 0;
  }
`

export const Title = styled.h1`
  text-transform: uppercase;
  font-weight: bold;
  opacity: 0;
  font-size: 16px;
  font-family: 'Amorin Sans Serif', 'serif';
  letter-spacing: .9px;
  transition: all .3s ease-in-out;
  transform: translateY(30px);
`

export const DescriptionContainer = styled.div`
  position: relative;
  display: flex; 
  width: 100%;
  min-height: 40px;
  justify-content: flex-end;
`

export const ArrowLeft = styled.div`
  position: absolute;
  top: 38px;
  right: 10px;
  width: 40px;
  min-height: 20px;
  background: url(${Arrow}) no-repeat;
  background-position: 60px 0px;
  transition: all .3s ease-in-out;
  z-index: 0;

  @media (min-width: 768px) {
    top: 42px;
    opacity: 0;
  }
`

export const TitleImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`

export const TitleImageContainer = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, calc(-50% - 50px));
  width: 70%;
  height: auto;
`